import { render, staticRenderFns } from "./JVxeDragSortCell.vue?vue&type=template&id=31577969"
import script from "./JVxeDragSortCell.vue?vue&type=script&lang=js"
export * from "./JVxeDragSortCell.vue?vue&type=script&lang=js"
import style0 from "./JVxeDragSortCell.vue?vue&type=style&index=0&id=31577969&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31577969')) {
      api.createRecord('31577969', component.options)
    } else {
      api.reload('31577969', component.options)
    }
    module.hot.accept("./JVxeDragSortCell.vue?vue&type=template&id=31577969", function () {
      api.rerender('31577969', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JVxeTable/components/cells/JVxeDragSortCell.vue"
export default component.exports